/** Safe message extraction for caught values under `useUnknownInCatchVariables`. */

export const getUnknownErrorMessage = (
  error: unknown,
  fallback = 'Server error',
): string => {
  if (error instanceof Error) {
    return error.message || fallback;
  }
  return fallback;
};
